import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { withPerformedAction } from "web_myplann/Api/Portfolio/withPerformedAction";
import {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
	type PortfolioAlertBoxListResponseDTO,
	type PortfolioEventTypeEnum,
	postPortfolioIdLeadV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type CreateLeadVariables = {
	contractId: number;
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
};

/**
 * Creates an advisor lead for a contract Event Alert ("Kontaktovat poradce").
 * The frontend sends only the event identity; the backend builds the whole lead
 * (product name + note + standard fields + advisor) from the contract.
 */
export const useCreatePortfolioLeadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, CreateLeadVariables>({
		mutationFn: processResponse(
			({ contractId, eventType, eventDate }: CreateLeadVariables) =>
				postPortfolioIdLeadV2({ eventType, eventDate }, contractId),
		),
		onSuccess: (_data, { contractId, eventType, eventDate }) => {
			queryClient.setQueriesData<PortfolioAlertBoxListResponseDTO | undefined>(
				{ queryKey: PortfolioKeys.alertBoxesAll(contractId) },
				(previous) => {
					if (!previous) {
						return previous;
					}
					return {
						...previous,
						alerts: previous.alerts.map((alert) =>
							alert.eventType === eventType && alert.eventDate === eventDate
								? withPerformedAction(
										alert,
										AlertBoxActionEnum.TalkToAgent,
										AlertBoxActionStateEnum.Sent,
									)
								: alert,
						),
					};
				},
			);
		},
	});
};
